"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require("react-modal");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Button = require("../Button");

var _Button2 = _interopRequireDefault(_Button);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

var _IconSvg = require("../IconSvg");

var _IconSvg2 = _interopRequireDefault(_IconSvg);

var _Image = require("../Image");

var _Image2 = _interopRequireDefault(_Image);

var _Divider = require("../Divider");

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const customStyle = {
  overlay: {
    backgroundColor: "rgba(33, 37, 48, 0.8)",
    zIndex: 2
  },
  content: {
    top: "0",
    left: "auto",
    right: "0",
    bottom: "0",
    padding: 0
  }
};

const CartModal = ({ isOpen, onClose, items, subtotal, tax }) => {
  return _react2.default.createElement(
    _reactModal2.default,
    { isOpen: isOpen, onRequestClose: onClose, style: customStyle },
    _react2.default.createElement(
      _Box2.default,
      { width: 448, py: 3 },
      _react2.default.createElement(
        _Flex2.default,
        { alignItems: "center", justifyContent: "space-between", px: 3 },
        _react2.default.createElement(_IconSvg2.default, { name: "close", color: "orange", onClick: onClose }),
        _react2.default.createElement(
          _Text2.default,
          { fontSize: 3, fontWeight: 500 },
          "My Bag"
        )
      ),
      items.map(item => {
        return _react2.default.createElement(
          _Flex2.default,
          { key: item.title, alignItems: "center", p: 3 },
          _react2.default.createElement(_Image2.default, {
            borderRadius: "50%",
            width: 40,
            height: "40px !important",
            src: item.imageUrl
          }),
          _react2.default.createElement(
            _Box2.default,
            { ml: 3 },
            _react2.default.createElement(
              _Box2.default,
              null,
              _react2.default.createElement(
                _Text2.default,
                { fontSize: 2, fontWeight: 600 },
                item.title
              )
            ),
            _react2.default.createElement(
              _Text2.default,
              { fontSize: 1, color: "palette.ink.600" },
              item.description
            )
          ),
          _react2.default.createElement(
            _Box2.default,
            { style: { marginLeft: "auto", marginRight: 0 } },
            _react2.default.createElement(
              _Box2.default,
              null,
              _react2.default.createElement(
                _Text2.default,
                { fontSize: 2, fontWeight: 600 },
                "$",
                item.price
              )
            ),
            _react2.default.createElement(
              _Text2.default,
              { color: "palette.ink.600" },
              "x",
              item.quantity
            )
          )
        );
      }),
      _react2.default.createElement(
        _Box2.default,
        { style: { position: "absolute", width: "100%", bottom: 0 }, px: 1 },
        _react2.default.createElement(_Divider2.default, null),
        _react2.default.createElement(
          _Flex2.default,
          {
            alignItems: "center",
            px: 2,
            py: 2,
            justifyContent: "space-between"
          },
          _react2.default.createElement(
            _Text2.default,
            { fontSize: 2, fontWeight: 600 },
            "Subtotal"
          ),
          _react2.default.createElement(
            _Text2.default,
            { fontSize: 2, fontWeight: 500 },
            "$",
            subtotal
          )
        ),
        _react2.default.createElement(
          _Flex2.default,
          {
            alignItems: "center",
            px: 2,
            pb: 2,
            justifyContent: "space-between"
          },
          _react2.default.createElement(
            _Text2.default,
            { fontSize: 2, fontWeight: 600 },
            "Tax"
          ),
          _react2.default.createElement(
            _Text2.default,
            { fontSize: 2, fontWeight: 500 },
            "$",
            tax
          )
        ),
        _react2.default.createElement(_Divider2.default, null),
        _react2.default.createElement(
          _Box2.default,
          { textAlign: "center", py: 3 },
          _react2.default.createElement(
            _Button2.default,
            { width: 400, variant: "green" },
            "Checkout"
          )
        )
      )
    )
  );
};

CartModal.propTypes = {
  isOpen: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  items: _propTypes2.default.array,
  subtotal: _propTypes2.default.float,
  tax: _propTypes2.default.float
};

CartModal.defaultProps = {
  items: [{
    title: "Pork Banh Mi",
    description: "No Cilantro, No Cucumber",
    imageUrl: "https://popmenucloud.com/cdn-cgi/image/width=1200,height=1200,fit=scale-down,format=auto,quality=60/vdegtjyh/e7424958-f38a-4b9a-9876-b038a85e77e5.jpg",
    price: "11",
    quantity: 2
  }],
  subtotal: 21.5,
  tax: 1.99
};

exports.default = CartModal;